<template>
  <div>
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";

export default {
  name: "guestok",
  data() {
    return {
    }
  },
  components: {
  },
  created() {
  },
  methods: {
  },
  computed: {
  },
  mounted() {
    let vue = this;
    let target = vue.$router.currentRoute.params.target;
    if (target != "chat" && target != "room") {
       vue.$router.push({ name: 'login' });
       return;
    }

    if (vue.$parent.isAuth()) {
      /* Already Authenticated */
      if (vx && vx.debug) { console.log("Guest Ok authed:"+target); }
      vue.$router.push({ name: target });
      return;
    }

    let href = vue.$router.resolve({ name: target }).href;
    href = href.replace("#","");
    if (vx && vx.debug) { console.log("Guest Ok login:"+href); }
    setLocal("vx_page_href",href);
    //vue.$router.allow_guest = true;
    //vue.$router.push({ name: 'login' });
    vue.$router.push({ name: 'guest' });
  },
};
</script>

<style lang="scss" scoped>
</style>
